const ANSWER = 'AGAVE';

  const game = document.getElementById('game');
  const message = document.getElementById('message');
  const maxAttempts = 6;
  let currentGuess = '';
  let currentRow = 0;

  for (let i = 0; i < maxAttempts; i++) {
    const row = document.createElement('div');
    row.className = 'row';
    for (let j = 0; j < 5; j++) {
      const tile = document.createElement('div');
      tile.className = 'tile';
      row.appendChild(tile);
    }
    game.appendChild(row);
  }

  const layout = [
    ['Q','W','E','R','T','Y','U','I','O','P'],
    ['A','S','D','F','G','H','J','K','L'],
    ['Enter','Z','X','C','V','B','N','M','⌫']
  ];

  layout.forEach((rowKeys, rowIndex) => {
    const rowDiv = document.getElementById(`row${rowIndex + 1}`);
    rowKeys.forEach(key => {
      const button = document.createElement('button');
      button.textContent = key === '⌫' ? 'Back' : key.toUpperCase();
      if (key === 'Enter' || key === '⌫') button.classList.add('wide');
      button.addEventListener('click', () => handleKey(key));
      rowDiv.appendChild(button);
    });
  });

  function handleKey(key) {
    if (message.textContent !== '') return;

    if (key === 'Enter') {
      if (currentGuess.length < 5) return;
      checkGuess();
    } else if (key === '⌫') {
      currentGuess = currentGuess.slice(0, -1);
      updateTiles();
    } else if (currentGuess.length < 5 && /^[A-Z]$/i.test(key)) {
      currentGuess += key.toUpperCase();
      updateTiles();
    }
  }

  function updateTiles() {
    const row = game.children[currentRow];
    for (let i = 0; i < 5; i++) {
      row.children[i].textContent = currentGuess[i] || '';
    }
  }

  function checkGuess() {
    const row = game.children[currentRow];
    const guess = currentGuess.toUpperCase();
    const answerArray = ANSWER.split('');
    const guessArray = guess.split('');
    const tileClasses = Array(5).fill('absent');

    for (let i = 0; i < 5; i++) {
      if (guessArray[i] === answerArray[i]) {
        tileClasses[i] = 'correct';
        answerArray[i] = null;
      }
    }

    for (let i = 0; i < 5; i++) {
      if (tileClasses[i] === 'correct') continue;
      const idx = answerArray.indexOf(guessArray[i]);
      if (idx !== -1) {
        tileClasses[i] = 'present';
        answerArray[idx] = null;
      }
    }

    for (let i = 0; i < 5; i++) {
      row.children[i].classList.add(tileClasses[i]);
    }

    if (guess === ANSWER) {
      message.textContent = '🎉 You Win!';
    } else {
      currentRow++;
      currentGuess = '';
      if (currentRow >= maxAttempts) {
        message.textContent = `❌ Game Over – The word was "${ANSWER}"`;
      }
    }
  }